import { useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore, { useSolutionDetails } from '../../redux';
import { API_ASSET_MAPING_CONFIG_DELETE } from '../../constants';
import { SolutionMappingConfigItem } from '../../types';

type Props = {
  item: SolutionMappingConfigItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionMappingDeleteModal({ item, open, onClose }: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);
  const [solutionDetails] = useSolutionDetails();
  const isISA95Standard =
    solutionDetails?.isIsa95Standard || false;
  const [handleDelete, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generateApiPath(API_ASSET_MAPING_CONFIG_DELETE, {
          solutionId,
          siteId: !isISA95Standard ? '00' : item?.siteId,
          twinId: item?.twinId,
          mappingId: item?.id,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: `Digital Twin Configuration Deleted`,
        text: 'Digital Twin Configuration has been deleted successfully',
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.assetMappingConfig({
        solutionId,
        siteId: !isISA95Standard ? '00' : item?.siteId,
        twinId: item?.twinId,
      });
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Delete Digital Twin Configuration"
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelBtnText="No"
      confirmBtnText="Yes"
      maxWidth="sm"
      fullWidth
    >
      Are you sure you want to delete the Digital Twin Configuration?<br></br>
      <b>{item?.path.split('ov/')[1]?.replace(/\/$/, '') || ''}</b>
    </ModalDialog>
  );
}

export default SolutionMappingDeleteModal;
